<template>
  <v-dialog
    id="dialog-popUp"
    class="elevation-0"
    box-shadow="none"
    v-model="dialog"
    max-width="590"
  >
    <template v-for="item in cardItem" target="_blank">
      <div :key="item.id" class="d-flex justify-end pb-1" @click="dialog = false">
        <span class="close">×</span>
      </div>
      <a :key="item.id" target="_blank" :href="item.link">
        <img :key="item.id" v-if="item.image" :src="item.image" width="100%" height="100%" alt="" />
      </a>
    </template>
  </v-dialog>
</template>

<script>
export default {
  props: {
    cardItem: { type: Array },
    isActive: { type: Boolean },
  },
  data() {
    return {
      dialog: false,
      overlay: false,
      zIndex: 0,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    ok() {
      this.dialog = false;
      this.$emit('ok');
    },
  },
};
</script>

<style scoped>
.close {
  font: 21px Open Sans;
  font-weight: bold;
  line-height: 1;
  color: #fff;
  text-shadow: 0 1px 0 #fff;
  cursor: pointer;
  padding: 5px 0 5px 5px;
}
</style>
